<template>
  <a class="data-grid-file-link-cell"
     :href="fileLink"
     target="_blank">{{cellText || '点击下载'}}</a>
</template>

<script>
export default {
  name: 'DataGridFileLinkCell',
  props: {
    cellValue: {
      type: String,
      required: true
    },
    cellParam: Object
  },
  computed: {
    cellText: function () {
      let cellParam = this.cellParam
      if (cellParam) {
        return cellParam.cellText
      }
    },
    fileLink: function () {
      return this.$contextPath(this.cellValue)
    }
  }
}
</script>

<style lang="scss">
  .data-grid-file-link-cell {
    text-decoration: none;
  }
</style>
